import '../styles/style.scss';
  import lazySizes from "lazysizes";
import './tools/lazybg';
import './tools/sharer';
import './tools/burger';
import './tools/backToTop';
//import AOS from 'aos';
// init animation on scroll
// AOS.init({
//     duration: 1000
// });
// Contact form

const thankYou = document.getElementById("thank-you");

if(thankYou) {
  console.log('thank you')
  thankYou.scrollIntoView({ behavior: 'smooth', block: 'start' });
  
}


